import { CommandType } from "@buildwithflux/models";
import { setDescription, setName, clearDocument } from "./baseDocument";
import { removePcbNodes, removePcbRuleSets, addPcbNodes, addPcbRuleSets, updatePcbNodes, updatePcbRuleSets } from "./pcb";
function applyCommand(snapshot, command, captureChangeUnitOfWorkOptions) {
    if (command.type === CommandType.enrichedAddPcbNodesCommand) {
        return addPcbNodes(snapshot, command, captureChangeUnitOfWorkOptions);
    }
    else if (command.type === CommandType.enrichedUpdatePcbNodesCommand) {
        return updatePcbNodes(snapshot, command, captureChangeUnitOfWorkOptions);
    }
    else if (command.type === CommandType.removePcbNodesCommand) {
        return removePcbNodes(snapshot, command, captureChangeUnitOfWorkOptions);
    }
    else if (command.type === CommandType.addPcbRuleSetsCommand) {
        return addPcbRuleSets(snapshot, command);
    }
    else if (command.type === CommandType.updatePcbRuleSetsCommand) {
        return updatePcbRuleSets(snapshot, command);
    }
    else if (command.type === CommandType.removePcbRuleSetsCommand) {
        return removePcbRuleSets(snapshot, command);
    }
    else if (command.type === CommandType.setDocumentDescriptionCommand) {
        return setDescription(snapshot, command, captureChangeUnitOfWorkOptions);
    }
    else if (command.type === CommandType.setDocumentNameCommand) {
        return setName(snapshot, command, captureChangeUnitOfWorkOptions);
    }
    else if (command.type === CommandType.clearDocumentCommand) {
        return clearDocument(snapshot, command, captureChangeUnitOfWorkOptions);
    }
    throw new Error(`Unknown command ${command.type}`);
}
export function createDocumentMutator() {
    return {
        applyCommand,
    };
}
//# sourceMappingURL=mutator.js.map